import React from "react";

import { Table } from "components/Sundry/Table/Modal";

export const Sundries = () => {
  // Do we need to look to see if there is a likely entry in the ledger entries?
  return <Table extraHeaderComponents={[]} />;
};
